/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import { Video } from "../../../../common/video/models/Video";
import VideoMetadataLine from "../../../../common/components/videoMetadataLine/VideoMetadataLine";
import {
  CommentHighlight,
  SceneHighlight,
  SearchHiglightSet,
} from "../../SearchResult";
import {
  Text16,
  Title24,
} from "../../../../common/components/typography/Typography";
import VideoPresenter from "../../../../common/components/video/presenter/VideoPresenter";
import styles from "./VideoSearchResult.module.css";
import SceneHighlightCard from "./SceneHighlightCard";
import { Highlight } from "./Highlight";
import CommentHighlightCard from "./CommentHighlightCard";
import LinearProgress from "@material-ui/core/LinearProgress";
import { createStyles, makeStyles } from "@material-ui/core";
import { isNullorUndefined } from "../../../../utils/ObjectUtils";
import useResponsive from "../../../../common/useResponsive";

interface VideoSearchResultProps {
  video: Video;
  isFirst: boolean;
  highlights?: SearchHiglightSet;
}

const useStyles = makeStyles(() =>
  createStyles({
    barColorPrimary: {
      backgroundColor: "var(--red)",
    },
  })
);

export default function VideoSearchResult({
  video,
  isFirst,
  highlights,
}: VideoSearchResultProps) {
  const classes = useStyles();
  const { isMobile } = useResponsive();

  // 進捗インジケータを計算
  const normalise = (video: Video) => {
    // console.log(video)
    if (video.viewingActivities.length === 0) {
      return 0;
    } else {
      const progressMillis = video.viewingActivities[0].progressMillis;
      const isFinished = video.viewingActivities[0].isFinished;
      if (progressMillis !== null) {
        var rate = Math.floor(
          (Number(progressMillis) / Number(video.durationMillis)) * 100
        );
        // console.log(rate)
        return rate;
      } else if (progressMillis === null && isFinished) {
        return 100;
      }
    }
  };

  return (
    <div className={styles.result}>
      <div className={styles.left}>
        <div className={styles.thumbnaildiv}>
          <Link to={`/video/${video.hash}`} target="_blank">
            <img className={styles.thumbnail} src={video.imageUrl} alt="" />
          </Link>
        </div>
        <LinearProgress
          className={styles.progressBar}
          classes={{ barColorPrimary: classes.barColorPrimary }}
          variant="determinate"
          value={normalise(video)}
        />

        <div className={styles.meta}>
          <VideoMetadataLine video={video} variant="compact" fontSize={isMobile ? 14 : 16} />
        </div>
      </div>

      <div className={styles.right}>
        <Link to={`/video/${video.hash}`} target="_blank">
          <div style={{ fontWeight: "bold" }}>
            {
              isMobile ?
              <Text16 lineHeight={1.2}>
                <UncertainHighlight
                  text={video.title}
                  highlights={highlights?.titleHighlights}
                />
              </Text16>
              :
              <Title24 lineHeight={1.2}>
                <UncertainHighlight
                  text={video.title}
                  highlights={highlights?.titleHighlights}
                />
              </Title24>
            }
          </div>
        </Link>

        {!isNullorUndefined(video.presenter) && (
          <VideoPresenter presenter={video.presenter} />
        )}

        {highlights && highlights?.descriptionHighlights.length > 0 && (
          <div className={styles.description}>
            <Text16 lineHeight={1.5}>
              <Highlight highlights={highlights.descriptionHighlights} />
            </Text16>
          </div>
        )}

        {highlights?.sceneHighlights &&
          highlights.sceneHighlights.map((highlight: SceneHighlight) => (
            <div className={styles.scene}>
              <SceneHighlightCard
                key={highlight.startMillis}
                video={video}
                highlight={highlight}
              />
            </div>
          ))}

        {highlights?.commentHighlights &&
          highlights.commentHighlights.map((highlight: CommentHighlight) => (
            <CommentHighlightCard
              key={highlight.created.getTime()}
              highlight={highlight}
            />
          ))}
      </div>
    </div>
  );
}

function UncertainHighlight({
  highlights,
  text,
}: {
  highlights?: string[];
  text: string;
}) {
  if (highlights && highlights.length > 0) {
    return <Highlight highlights={highlights} />;
  }

  return <span>{text}</span>;
}
